import { Space } from '../../../app/entities/space';
import { getFullName } from '../../../lib/utils/get-full-name';

import type { Project } from '../../../app/entities/project';

export interface CrewContactOption {
  label: string;
  value: string;
}

/**
 * The project's space contacts, shaped as `SingleSelectDropdown` options — shared by the
 * create/edit modal and the quick-assign modal so the two never derive this list differently.
 */
export const getCrewContactOptions = (project: Project): CrewContactOption[] => {
  const contacts = Space.getOne(project.spaceId)?.contacts || [];

  return contacts.map((contact) => ({
    label: getFullName(contact) || contact.email,
    value: contact._id,
  }));
};
